// extracted by mini-css-extract-plugin
export default {"pill":"StatusSelect_pill__-PgcE"};